import browserHydrateFunction from './src/utils/browserHydrateFunction';

export const replaceHydrateFunction = browserHydrateFunction;

const scheduleAfterStartup = (callback) => {
    if (typeof window === 'undefined') {
        return;
    }

    window.setTimeout(() => {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(callback, { timeout: 3000 });
            return;
        }

        callback();
    }, 9000);
};

export const onClientEntry = () => {
    scheduleAfterStartup(async () => {
        try {
            const { initializeParse } = await import("./src/utils/parse");
            await initializeParse();
        } catch (error) {
            // Do not block first paint if startup-only Parse warmup fails.
            console.error('Parse startup warmup failed:', error);
        }
    });
};
